export default __webpack_public_path__ + "static/media/timify-red-symbol.e15a5c03.svg";